export default function initialState() {
 return {
    form: {
      id: null,
      user_slug: null,
      client_id: null,
      property_id: null,
      type: 'listing',
      primary_source: null,
      date: null,
      price: 0,
      commission: 0,
      cos: 0,
      status: null,
      pipeline_rating: 5,
      client: {
        slug: null,
        name: null,
        phone: null,
        email: null
      },
      property: {
        id: null,
        address: null,
        city: null,
        state: null,
        zipcode: null
      },
      follow_up: true,
      follow_up_date: null,
    },
    client_type: 0,
    clients: null,
    errorList: null,
    howToVideo: null,
    howToTitle: null,
    person: null
  }
};